// Lucide icon: external-link (https://lucide.dev/icons/external-link)
import { ExternalLink } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconExternalLink = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <ExternalLink />
    </IconComponentStyled>
  )
}
